import { functions } from 'helpers/functions';

const getDependentsOf = (key: string, fields: any): any[] => {
  const keyTags = key.split('_');

  const dependents = fields.filter((field: any) => {
    const fieldKey = [keyTags[0] || '', field.campo_carregar, keyTags[2] || '']
      .filter(value => value && value.length > 0)
      .join('_');
    const tags = field.nome.split('_');
    return key === fieldKey && tags.length === keyTags.length;
  });

  return dependents.reduce((accumulator: any, dependent: any) => {
    return accumulator.concat(getDependentsOf(dependent.nome, fields));
  }, dependents);
};

export const getOptionsParametersShouldModify = (action: any, prevAction: any, options: any): string[] => {
  const selectedOption = options && Array.isArray(options) && options.find((item: any) => item.id === action.option_id);
  const selectedOptionHasUpdated = prevAction.option_id !== action.option_id;

  if (!selectedOption) {
    return [];
  }

  if (selectedOptionHasUpdated) {
    return selectedOption.parameters.campos.map((item: any) => item.nome);
  }

  if (!action.options_parameters) {
    return [];
  }

  const keys = Object.keys(action.options_parameters);

  const modifiedParameters = keys.filter((item: any) => {
    return !functions.isEqual(action.options_parameters[item], prevAction.options_parameters[item]);
  });

  return modifiedParameters.reduce((accumulator: any, item: any) => {
    const dependents = getDependentsOf(item, selectedOption.parameters.campos);

    if (dependents.length <= 0) {
      return accumulator;
    }

    return accumulator.concat(dependents.map((dependent: any) => dependent.nome));
  }, []);
};

export const getOptionParametersQuery = (item: any, selectedOption: any, action: any) => {
  const toSearch = `pvo_${item.campo_carregar}`;
  const tags = item.nome.split('_');
  const dependentName = [tags[0] || '', item.campo_carregar, tags[2] || '']
    .filter(value => value && value.length > 0)
    .join('_');

  const dependentsWhoHaveDependents = selectedOption.parameters.campos.filter(
    (dependent: any) => dependent.nome === dependentName && dependent.campo_carregar
  );

  return dependentsWhoHaveDependents.reduce(
    (accumulator: Record<string, any>, dependent: any) => {
      const dependentToSearch = `pvo_${dependent.campo_carregar}`;
      const dependentTags = dependent.nome.split('_');

      const dependentDependentName = [dependentTags[0] || '', dependent.campo_carregar, dependentTags[2] || '']
        .filter(value => value && value.length > 0)
        .join('_');

      accumulator[dependentToSearch] = action.options_parameters[dependentDependentName]
        ? action.options_parameters[dependentDependentName]
        : null;

      return accumulator;
    },
    {
      [toSearch]: action.options_parameters[dependentName] ? action.options_parameters[dependentName] : null
    }
  );
};
